import { useState, useEffect } from 'react';

function handleScroll() {
  const { scrollHeight, scrollTop, clientHeight } = this.dom;
  this.setIsTouchBottom(scrollHeight - (scrollTop + clientHeight) === 0);
}

export default function useDetectScrollBottom(id) {
  const [isTouchBottom, setIsTouchBottom] = useState(false);

  useEffect(() => {
    const dom = document.getElementById(id);
    dom.addEventListener(
      'scroll',
      handleScroll.bind({
        dom,
        setIsTouchBottom,
      }),
    );

    return () => {
      dom.removeEventListener('scroll', handleScroll);
      return false;
    };
  }, []);

  return isTouchBottom;
}
